export var DISPLAY_WIDTH;
(function (DISPLAY_WIDTH) {
  DISPLAY_WIDTH[DISPLAY_WIDTH["MOBILE"] = 767] = "MOBILE";
  DISPLAY_WIDTH[DISPLAY_WIDTH["TABLET"] = 1024] = "TABLET";
})(DISPLAY_WIDTH || (DISPLAY_WIDTH = {}));
export var VIEW_ANALYTICS_TYPES = {
  teaser: 'main_banner_view',
  info: 'banner_other_view',
  tariff: 'tariffblock_view',
  steps: 'steps_view',
  video: 'video_view',
  faq: 'FAQ_view',
  card: 'block_other_view',
  form: 'form_view',
  action_bar: 'flexbutton',
  app_banner: 'app_block_view',
  modal: 'popup_view'
};
export var CLICK_ANALYTICS_TYPES = {
  teaser: 'main_banner_click',
  info: 'banner_other_click',
  stepsTab: 'steps_tab_click',
  steps: 'steps_click',
  faqTab: 'FAQ_tab_click',
  faq: 'FAQ_click',
  video: 'video_play',
  card: 'block_other_click',
  tariff: 'tariffblock_click',
  form: 'form_submit',
  action_bar: 'flexbutton_click',
  app_banner: 'app_block_click',
  link: 'link_click',
  modal: 'popup_click',
  tabs: 'tabs_click',
  service: 'service_click'
};
export var REACH_GOAL_CLICK_TYPE = {
  InternalLinkClick: 'InternalLinkClick',
  OutgoingLinkClick: 'OutgoingLinkClick',
  BuyButtonClick: 'BuyButtonClick',
  VideoPlay: 'VideoPlay',
  FormSubmit: 'FormSubmit',
  PopupView: 'PopupView',
  PopupButtonClick: 'PopupButtonClick'
};